<template>
  <div>
    <b-modal :id="modalId" class="subscribe-modal" centered>
    <div>
      <div class="top-modal">
        <h2 class="modal-title">{{$t('modal_title')}}</h2>
        <p>{{$t('modal_msg')}}</p>
      </div>
      <div class="bottom-modal">
        <div class="form-container"></div>
        <p>{{$t('modal_text')}}</p>
      </div>
    </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      modalId: 'modal-center' // Унікальний ідентифікатор модального вікна
    }
  },
  methods: {
    showModal () {
      this.$root.$emit('bv::show::modal', this.modalId)
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/app.scss";
  .subscribe-modal{
    .modal-header{
      display: none;
    }

     .top-modal{
        .modal-title{
          color: #7A7CE8;
          text-align: center;
          font-family: $main-font;
          font-size: 40px;
          font-style: normal;
          font-weight: 700;
          line-height: 48px;
          margin: 0 0 24px 0;
        }
        p{
          color: #6D788C;
          text-align: center;
          font-family: $main-font;
          font-size: 18px;
          font-style: normal;
          font-weight: 300;
          line-height: 25.2px;
          margin: 0;
        }
      }
      .bottom-modal{
        background: #7A7CE8;
        padding: 24px 0 48px 0;
      }
  }
</style>
